/* global navigator */

const GEO_TIMEOUT_MS = 8000

export class InspectionForm {
  constructor () {
    this.form = document.getElementById('inspectionForm')
    this.latitude = document.getElementById('inspectionLatitude')
    this.longitude = document.getElementById('inspectionLongitude')
    this.status = document.getElementById('inspectionGeoStatus')
    this.offlineAlert = document.getElementById('inspectionOfflineAlert')
    this.retryButton = document.getElementById('inspectionRetry')
    this.watchId = null
    this.retryPending = false
  }

  init () {
    this.watchLocation()
    if (!this.form) { return }
    this.form.addEventListener('turbo:submit-start', () => this.hideOfflineAlert())
    this.form.addEventListener('turbo:submit-end', event => this.onSubmitEnd(event))
    if (this.retryButton) { this.retryButton.addEventListener('click', () => this.retry()) }
    window.addEventListener('online', () => { if (this.retryPending) { this.retry() } })
  }

  watchLocation () {
    if (!this.latitude || !navigator.geolocation) { return }
    this.setStatus('Getting location...')
    this.watchId = navigator.geolocation.watchPosition(
      position => this.setCoordinates(position.coords),
      () => this.setStatus('Location unavailable.'),
      { timeout: GEO_TIMEOUT_MS, enableHighAccuracy: true }
    )
  }

  onSubmitEnd (event) {
    const detail = event.detail || {}
    if (detail.success) {
      this.retryPending = false
      this.stopWatching()
    } else if (!detail.fetchResponse) {
      this.onConnectionError()
    }
  }

  onConnectionError () {
    this.retryPending = true
    this.showOfflineAlert()
  }

  retry () {
    this.hideOfflineAlert()
    this.form.requestSubmit()
  }

  setCoordinates (coords) {
    this.latitude.value = coords.latitude
    this.longitude.value = coords.longitude
    this.setStatus('Location captured.')
  }

  stopWatching () {
    if (this.watchId !== null) {
      navigator.geolocation.clearWatch(this.watchId)
      this.watchId = null
    }
  }

  showOfflineAlert () {
    if (this.offlineAlert) { this.offlineAlert.classList.remove('d-none') }
  }

  hideOfflineAlert () {
    if (this.offlineAlert) { this.offlineAlert.classList.add('d-none') }
  }

  setStatus (text) {
    if (this.status) { this.status.textContent = text }
  }
}
